/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type CitrusCarouselResponse } from '@/features/citrus';

export const getSkuIdsForSearchPage = (
  searchProductSkus: string[],
  citrusSearchPageData: CitrusCarouselResponse | undefined,
): {
  skuIds: string[];
  sponsoredSkus: string[];
  resultSkus: string[];
} => {
  const citrusSponsoredSkus =
    citrusSearchPageData?.ads
      .slice(0, 3)
      .map((ad) => ad.gtin)
      .filter(Boolean) ?? [];

  const allSkus = new Set([...citrusSponsoredSkus]);
  const resultSkus: string[] = [];

  // Remove duplicate SKU IDs
  for (const sku of searchProductSkus) {
    if (!allSkus.has(sku)) {
      allSkus.add(sku);
      resultSkus.push(sku);
    }
  }

  return {
    skuIds: Array.from(allSkus),
    sponsoredSkus: citrusSponsoredSkus,
    resultSkus,
  };
};
